/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
// methods for the Blink Application model

import jsonParse from "utils/jsonParse";

const isFeedbackSent = (status) => status === 3;

export const checkIfUserApplicationHasErrors = (user) => {
  if (user && user.application) {
    const { blink_system_errors, blink_id_status } = user.application;
    if (
      // blink_system_errors &&
      // blink_system_errors.length > 0 &&
      isFeedbackSent(blink_id_status)
    ) {
      return true;
    }
  }
  return false;
};

export const parseApplicationErrors = (user) => {
  if (user && user.application) {
    const { blink_system_errors } = user.application;
    if (blink_system_errors && blink_system_errors.length > 0) {
      return jsonParse(blink_system_errors);
    }
  }
  return null;
};

export const mapApplicationErrorsToFields = (user) => {
  const errors = parseApplicationErrors(user);
  const assignField = (field) => field?.comment ?? "";
  const fields = {};
  fields["firstName"] = assignField(errors?.first_name);
  fields["lastName"] = assignField(errors?.last_name);
  fields["email"] = assignField(errors?.email);
  fields["phoneNumber"] = assignField(errors?.contact_number);
  // TODO: passport, portrait
  fields["passportNumber"] = assignField(errors?.document_number);
  fields["issuingAuthority"] = assignField(errors?.document_issuing_authority);
  fields["expireDate"] = assignField(errors?.document_expiration_date);
  fields["gender"] = assignField(errors?.gender);
  fields["dateOfBirth"] = assignField(errors?.birth_date);
  fields["email"] = assignField(errors?.email);
  fields["emergencyContactFullName"] = assignField(
    errors?.emergency_contact_full_name
  );
  fields["emergencyPhoneNumber"] = assignField(
    errors?.emergency_contact_phone_number
  );
  fields["nationality"] = assignField(errors?.nationality);
  fields["firstNameInArabic"] = assignField(errors?.arabic_first_name);
  fields["lastNameInArabic"] = assignField(errors?.arabic_last_name);
  fields["portrait"] = assignField(errors?.portrait);
  fields["passport"] = assignField(errors?.passport);
  return fields;
};

export const getApplicationStatus = (user) => {
  if (user && user.application) {
    const { blink_id_status } = user.application;
    return blink_id_status;
  }
  return user?.blink_id_status || 0;
};

export const getApplicationStatusText = (user) => {
  const APP_STATUS = (state) =>
    ({
      1: "pending",
      2: "processing",
      6: "pending",
      3: "denied",
      4: "approved",
      0: "initial",
    }[state] || "initial");

  const status = getApplicationStatus(user);
  return APP_STATUS(status);
};

export const getApplication = (user) => {
  if (user && user.application) {
    return user.application;
  }
  return null;
};
